import { icons, genesisIcons } from '@formkit/icons'
import { plugin as formKitPlugin, defaultConfig } from '@formkit/vue'
import { createProPlugin, inputs } from '@formkit/pro'
import { generateClasses } from '@formkit/themes'
import { rootClasses } from '../../../formkit.theme'

import { de } from '@formkit/i18n'

const formkitProPlugin = createProPlugin('fk-8e79d66697a', inputs)

const config = defaultConfig({
  locale: 'de',
  locales: { de },
  plugins: [formkitProPlugin],
  config: {
    rootClasses,
    classes: generateClasses({
      global: {
        legend: 'font-semibold leading-normal text-lg mb-6',
        messages: 'list-none p-0 mt-1 mb-0',
        message: 'text-red-500 mb-1 text-xs',
        help: 'text-xs text-gray-500',
        label: 'block font-semibold leading-normal text-lg mb-1',
        inner:
          'formkit-disabled:bg-gray-200 formkit-disabled:cursor-not-allowed formkit-disabled:pointer-events-none formkit-disabled:opacity-50 flex',
        input: 'appearance-none bg-transparent focus:outline-none focus:ring-0 focus:shadow-none',
        loaderIcon: 'inline-flex items-center w-4 text-gray-600 animate-spin',
        outer: 'mb-4',
        prefixIcon:
          'w-10 flex self-stretch grow-0 shrink-0 rounded-tl rounded-bl border-r border-gray-400 bg-white bg-gradient-to-b from-transparent to-gray-200 [&>svg]:w-full [&>svg]:max-w-[1em] [&>svg]:max-h-[1em] [&>svg]:m-auto',
        suffixIcon:
          'w-7 pr-3 border-l-gray-400 flex self-stretch grow-0 shrink-0 [&>svg]:w-full [&>svg]:max-w-[1em] [&>svg]:max-h-[1em] [&>svg]:m-auto',
      },
      'family:text': {
        label: 'font-semibold leading-normal text-lg mb-1',
      },
      'family:box': {
        decorator:
          'block relative ring-2  mr-2 rounded bg-white bg-gradient-to-b from-transparent to-gray-200 ring-gray-400 peer-checked:ring-secondary text-transparent peer-checked:text-blue-500',
        decoratorIcon: 'flex p-[3px] w-full h-full absolute top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2 bg-red',
        help: 'mb-2 mt-1.5',
        input: 'absolute w-0 h-0 overflow-hidden opacity-0 pointer-events-none peer',
        label: '$reset text-sm text-gray-700 mt-1 select-none',
        wrapper: 'flex items-center mb-1',
      },
      'family:button': {
        input: '$reset inline-flex items-center bg-blue-600 text-white text-sm font-normal py-3 px-6 rounded',
        wrapper: 'mb-1',
        prefixIcon: '$reset block w-4 -ml-2 mr-2 stretch',
        suffixIcon: '$reset block w-4 ml-2 stretch',
      },
      'family:dropdown': {
        dropdownWrapper: 'my-2 w-full drop-shadow-lg rounded [&::-webkit-scrollbar]:hidden',
        emptyMessageInner: 'flex items-center justify-center text-sm p-2 text-center w-full text-gray-500 [&>span]:mr-3 [&>span]:ml-0',
        inner:
          'relative flex ring-1 ring-gray-400 focus-within:ring-blue-500 focus-within:ring-2 rounded mb-1 formkit-disabled:focus-within:ring-gray-400 formkit-disabled:focus-within:ring-1 [&>span:first-child]:focus-within:text-blue-500',
        input: 'w-full px-3 py-2',
        listbox: 'bg-white drop-shadow-lg rounded overflow-hidden',
        listboxButton: 'flex w-12 self-stretch justify-center mx-auto',
        listitem:
          'pl-7 relative hover:bg-gray-300 data-[is-active="true"]:bg-gray-300 data-[is-active="true"]:aria-selected:bg-blue-600 aria-selected:bg-blue-600 aria-selected:text-white',
        loaderIcon: 'ml-auto',
        loadMoreInner:
          'flex items-center justify-center text-sm p-2 text-center w-full text-blue-500 formkit-loading:text-gray-500 cursor-pointer [&>span]:mr-3 [&>span]:ml-0',
        option: 'p-2.5',
        optionLoading: 'text-gray-500',
        placeholder: 'p-2.5 text-gray-400',
        selector: 'flex w-full justify-between items-center [&u]',
        selectedIcon: 'block absolute top-1/2 left-2 w-3 -translate-y-1/2',
        selectIcon: 'flex box-content w-4 px-2 self-stretch grow-0 shrink-0',
      },
      password: {
        outer: 'mb-5',
        label: 'block mb-1 ',
        inner: 'border border-gray-400 rounded mb-1 overflow-hidden focus-within:border-blue-500',
        input: 'w-full h-10 px-3 border-none text-base text-gray-700 placeholder-gray-400',
        help: 'text-xs text-gray-500',
      },
      email: {
        outer: 'mb-5',
        label: 'block mb-1 ',
        inner: 'border border-gray-400 rounded mb-1 overflow-hidden focus-within:border-blue-500',
        input: 'w-full h-10 px-3 border-none text-base text-gray-700 placeholder-gray-400',
        help: 'text-xs text-gray-500',
      },
      text: {
        outer: 'mb-5',
        label: 'block mb-1 ',
        inner: 'border border-gray-400 rounded mb-1 overflow-hidden focus-within:border-blue-500 ',
        input: 'w-full h-8 px-2 border-none text-base text-gray-700 placeholder-gray-400',
        help: 'text-xs text-gray-500',
      },
      number: {
        input:
          'w-full border h-10 border-gray-300 rounded font-semibold text-base placeholder:text-black/20 placeholder:font-semibold placeholder:text-bas',
      },
      currency: {
        inner: '',
        input:
          'w-full   border h-10 border-gray-300 rounded font-semibold text-base placeholder:text-black/20 placeholder:font-semibold placeholder:text-bas',
      },
      radio: {
        wrapper:
          'w-full  flex items-baseline p-6 data-[checked=true]:border-secondary border border-gray rounded-lg mb-2 cursor-pointer border rounded bg-white hover:border-secondary hover:bg-secondary-50',
        input: 'mx-5',
        decorator: 'rounded-full',
        decoratorIcon: 'w-5 p-[5px]',
      },
      select: {
        inner:
          'w-full flex relative  items-center rounded mb-1 ring-1 ring-gray-400 focus-within:ring-blue-500 focus-within:ring-2 [&>span:first-child]:focus-within:text-blue-500',
        input:
          'w-full pl-3 pr-8 py-2 border-none text-base text-gray-700 placeholder-gray-400 formkit-multiple:p-0 data-[placeholder="true"]:text-gray-400 formkit-multiple:data-[placeholder="true"]:text-inherit',
        selectIcon: 'flex p-[3px] shrink-0 w-5 mr-2 -ml-[1.5em] h-full pointer-events-none',
        option: 'formkit-multiple:p-3 formkit-multiple:text-sm text-gray-700',
      },
      textarea: {
        inner: 'flex  rounded mb-1 ring-1 ring-gray-400 focus-within:ring-blue-500 [&>label:first-child]:focus-within:text-blue-500',
        input: 'block w-full h-32 px-3 py-3 border-none text-base text-gray-700 placeholder-gray-400 focus:shadow-outline',
      },
      range: {
        inner: '$reset flex items-center ',
        input: '$reset w-full mb-1 h-2 p-0 rounded-full',
        prefixIcon: '$reset w-4 mr-1 flex self-stretch grow-0 shrink-0 [&>svg]:max-w-[1em] [&>svg]:max-h-[1em] [&>svg]:m-auto',
        suffixIcon: '$reset w-4 ml-1 flex self-stretch grow-0 shrink-0 [&>svg]:max-w-[1em] [&>svg]:max-h-[1em] [&>svg]:m-auto',
      },
      checkbox: {
        wrapper:
          'w-full flex items-baseline p-6 data-[checked=true]:border-secondary border border-gray rounded-lg mb-2 cursor-pointer border rounded bg-white hover:border-secondary hover:bg-secondary-50',
        input: 'mx-5 rounded-full',
        decorator: 'rounded-full',
        decoratorIcon: 'w-5 p-[5px]',
      },
      date: {
        inner: 'items-center  border border-gray-300 rounded w-full',
        input:
          'w-full border border-gray-300 rounded font-semibold text-base placeholder:text-black/20 placeholder:font-semibold placeholder:text-base',
      },
      datepicker: {
        wrapper: 'w-full',
        inner: 'w-full items-center border border-gray-300 rounded',
        input: 'h-10 w-full font-semibold text-base placeholder:text-black/20 placeholder:font-semibold placeholder:text-base',
      },
      autocomplete: {
        closeIcon: 'block grow-0 shrink-0 w-3 mr-3.5',
        input: 'border-none',
        inner: '[&>div>[data-value]]:absolute [&>div>[data-value]]:mb-0 w-full h-14 ',
        option: 'grow text-ellipsis',
        selection: 'static flex left-0 top-0 right-0 bottom-0 mt-0 mb-2 rounded bg-gray-100',
      },
      repeater: {
        content: 'grow p-3 flex flex-col align-center',
        controlLabel: 'absolute opacity-0 pointer-events-none',
        controls: 'flex flex-col items-center justify-center bg-gray-100 p-3',
        downControl: 'hover:text-blue-500 disabled:hover:text-inherit disabled:opacity-25',
        fieldset: 'py-4 px-5',
        help: 'mb-2 mt-1.5',
        item: 'flex w-full mb-1 rounded border border-gray-200',
        moveDownIcon: 'block w-3 my-1',
        moveUpIcon: 'block w-3 my-1',
        removeControl: 'hover:text-blue-500 disabled:hover:text-inherit disabled:opacity-25',
        removeIcon: 'block w-5 my-1',
        upControl: 'hover:text-blue-500 disabled:hover:text-inherit disabled:opacity-25',
      },
    }),
  },
  icons: {
    ...icons,
    ...genesisIcons,
  },
})
export { formKitPlugin, config }
